import { createErrorDataSelector } from 'selectors/selectorUtils';
import { createSelector } from 'reselect';
import { getOrganizations } from 'helpers/selectors';

const getGatewayEventLogFilters = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.filters;
};

const getGatewayEventLogLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.gatewayEventLogLoadingStatus;
};

const getGatewayEventsLog = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.gatewayEventLogs;
};

const getNextCursor = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.nextCursor;
};

const getHasMoreData = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.hasMoreData;
};

const getIsLoadingMore = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.isLoadingMore;
};

const getGatewayEventsLogError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.gatewayEventsLog?.gatewayEventLogLoadingStatus,
        error: powertrainTools?.gatewayEventsLog?.gatewayEventLogsError,
        errorCode: powertrainTools?.gatewayEventsLog?.gatewayEventLogsError?.statusCode
    };
};

// Memoized selector for default gateway events log error data
const getGatewayEventsLogErrorData = createErrorDataSelector(getGatewayEventsLogError);

const getGatewayEventAttachmentError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.gatewayEventsLog?.gatewayAttachment?.loadingStatus,
        error: powertrainTools?.gatewayEventsLog?.gatewayAttachment?.error,
        errorCode: powertrainTools?.gatewayEventsLog?.gatewayAttachment?.error?.statusCode
    };
};

// Memoized selector for default gateway event attachment error data
const getGatewayEventAttachmentErrorData = createErrorDataSelector(getGatewayEventAttachmentError);

export const getDownloadLogsLimitCheck = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.downloadLogsLimitCheck;
};

export const getDownloadLogsZip = ({ powertrainTools }) => {
    return powertrainTools?.gatewayEventsLog?.downloadLogsZip;
};

export const getModel = createSelector([
    getGatewayEventLogFilters,
    getGatewayEventLogLoadingStatus,
    getGatewayEventsLog,
    getNextCursor,
    getHasMoreData,
    getIsLoadingMore,
    getGatewayEventsLogErrorData,
    getGatewayEventAttachmentErrorData,
    getOrganizations
], (
    filters,
    gatewayEventLogLoadingStatus,
    gatewayEventsLog,
    nextCursor,
    hasMoreData,
    isLoadingMore,
    gatewayEventsLogErrorData,
    getGatewayEventAttachmentErrorData,
    organizations
) => {
    return {
        filters,
        gatewayEventLogLoadingStatus,
        gatewayEventsLog,
        nextCursor,
        hasMoreData,
        isLoadingMore,
        gatewayEventsLogErrorData,
        getGatewayEventAttachmentErrorData,
        organizations: organizations || []
    };
});
